<template>
  <div class="sponsor-card" :class="button && '--button'">
    <div class="sponsor-card__icon">
      <IconDouble class="icon" />
    </div>
    <div class="sponsor-card__description">
      <p v-if="subtitle" class="sponsor-card__description-title">
        {{ subtitle }}
      </p>
      <p>{{ title }}</p>
    </div>
    <div v-if="button" class="sponsor-card__arrow-icon">
      <svgo-arrow-right class="icon" />
    </div>
  </div>
</template>

<script setup>
import IconDouble from '~/components/Icons/SponsorDoubleIcon.vue';

defineProps({
  sponsor: {
    type: Object,
    default: () => ({}),
  },
  button: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss">
@use '@/assets/styles/components/pages/project/sponsorCard.scss' as *;
</style>
